import "../Accessing/Accessing.css";
import "./Addressing.css";
import React from "react";
import { Link } from "react-router-dom";

let rand = String(Math.floor(Math.random() * 1000));

class Block extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			blockValue: Math.floor(Math.random() * 100),
		};
		this.onBlockHover = this.onBlockHover.bind(this);
	}

	onBlockHover() {
		let index = this.props.id;
		let location =
			"0x0" + rand + String(2 * parseInt(index.slice(index.length - 1)));
		document.getElementById(this.props.id).title =
			"Memory location: " + location;
	}

	render() {
		return (
			<div
				onMouseOver={this.onBlockHover}
				id={this.props.id}
				className="addr-block"
			>
				{this.state.blockValue}
			</div>
		);
	}
}

let arr = [];

for (let i = 0; i < 10; i++) {
	arr.push(<Block id={"addr" + String(i)} />);
}

export default class Addressing extends React.Component {
	componentDidMount() {
		document.title = 'Addressing in Arrays | Array Bundle';
		window.scroll(0,0);
	}

	render() {

		return (
			<div className="subbundle-main">
				<h1 style={{textAlign: 'center', fontFamily: 'Gilroy', textDecoration: 'underline', fontSize: '2rem'}}><Link to="/">Go to Home</Link></h1>
				<h1>Addressing in Arrays</h1>
				<p>
					A very essential part of arrays is to understand how the
					compiler knows where individual elements of array are located in
					memory. So, let us understand how is it done.
				</p>
				<p>
					You will be surprised to know that when we use the array name,
					we are referring to nothing but the <b>first byte</b> of the
					array. Array name corresponds to the address of the first byte
					of the array.
				</p>
				<p>
					The subscripts or index are <b>offset</b>, i.e. you can say the
					distance from the starting location of the array. Also, all the
					elements are located in consecutive memory locations. Thus using
					the name of array which is the base address and offset,
					languages like <code>C/C++/Java</code> calculate addresses of
					all elements in <b>run-time.</b>
				</p>
				<p>
					The formula to calculate memory address is as follows: <br />
					<code>
						<i>
							Address of element of a[i] = base address of array a[] +
							data_type_size * (i - starting index )
						</i>
					</code>
				</p>
				<img src="https://www.studymite.com/wp-content/uploads/2018/11/accessing-elements-in-array.png" />
				<p>
					Take a look at the above example. <br /> As we know storing{" "}
					<code>int</code> requires <b>2 bytes</b>. Also,{" "}
					<b>data_type_size = 2</b>, <b>starting index = 0</b>, base
					address of array <code>rollno[] = 2000</code> and <b>i=3</b>.{" "}
					<br />
					<br />
					Hence{" "}
					<code>rollno[3] = 2000 + 2 * (3 - 0) = 2000 + 6 = 2006</code>.
				</p>
	
				<hr />
				<h1>GAME TIME!</h1>
				<div className="subbundle-game-container">
					<h1 style={{ textAlign: "center", fontFamily: "Poppins" }}>
						Hover your mouse to look at the <br /> memory locations of
						each individual block...
					</h1>
					<div className="addr">{arr}</div>
				</div>
				<div className="next-previous-div">
					<Link to="/games/arrays/accessing">
						<span>
							{"<"}Prev <b>Accessing in Arrays</b>
						</span>
					</Link>
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					<Link to="/games/arrays/rotation">
						<span>
							Next{">"} <b>Array Rotation</b>
						</span>
					</Link>
				</div>
			</div>
		);
	}
}
